const subscription = {};

const subscribe = (eventName, callback) => {
    if (!subscription[eventName]) {
        subscription[eventName] = new Set();
    }

    const callbacks = subscription[eventName];
    callbacks.add(callback);

    return () => {
        callbacks.delete(callback);

        if (callbacks.size === 0) {
            delete subscription[eventName];
        }
    };
};

const broadcast = (eventName, ...args) => {
    if (!subscription[eventName]) {
        throw `Не удалось найти broadcast ${eventName}`;
    }
    const callbacks = subscription[eventName];

    for (const callback of callbacks) {
        callback(...args);
    }
};

export default {
    subscribe,
    broadcast,
};
